<template>
  <div>
    <el-form inline :model="searchData">
      <el-form-item>
        <el-input
          placeholder="备注"
          clearable
          prefix-icon="el-icon-search"
          v-model="searchData.searchInputValue"
          style="width: 250px"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="商品规格">
        <CommoditySpecSelect
          v-model="searchData.commoditySpecIdList"
          :commodityId="commodityId"
          @change="changeAndSearch"
        >
        </CommoditySpecSelect>
      </el-form-item>
      <el-form-item label="变动类型">
        <EnumSelect
          enumName="CommodityQuantityDetailChangeTypeEnum"
          :multiple="false"
          placeholder="请选择变动类型"
          v-model="searchData.changeTypeEnum"
          @change="changeAndSearch"
        ></EnumSelect>
      </el-form-item>
      <el-form-item label="变动时间">
        <DateRangePicker
          :minVal.sync="searchData.minCreateDate"
          :maxVal.sync="searchData.maxCreateDate"
          @change="changeAndSearch"
        ></DateRangePicker>
      </el-form-item>
      <el-form-item>
        <el-button
          icon="el-icon-search"
          type="primary"
          size="mini"
          @click="changeAndSearch"
          :loading="searchLoading"
        >
          查询
        </el-button>
        <el-button
          icon="el-icon-refresh"
          size="mini"
          @click="resetAndSearch"
          :loading="searchLoading"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="searchLoading"
      :data="searchRes && searchRes.data ? searchRes.data : []"
      stripe
      :row-key="
        (row) => {
          return row.id + row.lastEditTime;
        }
      "
      ref="refsTable"
      @sort-change="sortChange"
      max-height="400px"
    >
      <el-table-column
        prop="changeTypeEnum.Desc"
        label="变动类型"
        width="150"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="commoditySpec.specName"
        label="关联商品规格"
        width="150"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="wareHouse"
        label="关联仓库"
        width="150"
        align="left"
        header-align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-fmtype="scope.row.wareHouse ? '' : 'warning'">{{
            scope.row.wareHouse ? scope.row.wareHouse.name : "未关联仓库"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="fictitiousChangeQuantity"
        label="变动信息"
        min-width="250"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          {{ getChangeText(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="250"
        align="left"
        header-align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        width="200"
        align="center"
        header-align="center"
        sortable="custom"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="searchRes && searchRes.pageInfo"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchRes.pageInfo.page"
      :page-sizes="[5, 10, 20, 50, 100]"
      :page-size="searchRes.pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchRes.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityQuantityDetailSearchTable",
  props: {
    commodityId: [String],
  },
  watch: {
    commodityId: {
      handler(newVal, val) {
        this.searchRes = {};
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchLoading: false,
      searchData: {
        commoditySpecIdList: null,
        changeTypeEnum: null,
        minCreateDate: null,
        maxCreateDate: null,
        frozen: null,
      },
      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["remark"],
            quickSearchValue: null,
          },
        ],
        commodityId: null,
        commoditySpecIdList: null,
        changeTypeEnum: null,
        minCreateDate: null,
        maxCreateDate: null,
        frozen: null,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        sortInfo: null,
      },
      searchRes: {},
    };
  },

  mounted() {},

  methods: {
    getChangeText(item) {
      let res = [];
      if (item.fictitiousChangeQuantity && item.fictitiousChangeQuantity != 0) {
        res.push(
          "虚拟库存 " +
            (item.fictitiousChangeQuantity > 0 ? "+" : " ") +
            item.fictitiousChangeQuantity
        );
      }
      if (
        this.$jsTool.currentUserCanSeePrice() &&
        item.fictitiousChangeMwAmount &&
        item.fictitiousChangeMwAmount != 0
      ) {
        res.push(
          "虚拟库存成本 " +
            (item.fictitiousChangeMwAmount > 0 ? "+" : " ") +
            item.fictitiousChangeMwAmount
        );
      }
      if (item.availableChangeQuantity && item.availableChangeQuantity != 0) {
        res.push(
          "可用库存 " +
            (item.availableChangeQuantity > 0 ? "+" : " ") +
            item.availableChangeQuantity
        );
      }
      if (item.toBeInputChangeQuantity && item.toBeInputChangeQuantity != 0) {
        res.push(
          "待入库数量 " +
            (item.toBeInputChangeQuantity > 0 ? "+" : " ") +
            item.toBeInputChangeQuantity
        );
      }
      if (item.inputingChangeQuantity && item.inputingChangeQuantity != 0) {
        res.push(
          "入库中数量 " +
            (item.inputingChangeQuantity > 0 ? "+" : " ") +
            item.inputingChangeQuantity
        );
      }
      if (item.toBeOutputChangeQuantity && item.toBeOutputChangeQuantity != 0) {
        res.push(
          "待出库数量 " +
            (item.toBeOutputChangeQuantity > 0 ? "+" : " ") +
            item.toBeOutputChangeQuantity
        );
      }
      if (item.outputingChangeQuantity && item.outputingChangeQuantity != 0) {
        res.push(
          "出库中数量 " +
            (item.outputingChangeQuantity > 0 ? "+" : " ") +
            item.outputingChangeQuantity
        );
      }
      if (item.lossingChangeQuantity && item.lossingChangeQuantity != 0) {
        res.push(
          "报损中数量 " +
            (item.lossingChangeQuantity > 0 ? "+" : " ") +
            item.lossingChangeQuantity
        );
      }
      if (
        item.completedLossChangeQuantity &&
        item.completedLossChangeQuantity != 0
      ) {
        res.push(
          "已报损数量 " +
            (item.completedLossChangeQuantity > 0 ? "+" : " ") +
            item.completedLossChangeQuantity
        );
      }
      if (item.transferOutChangeQuantity && item.transferOutChangeQuantity != 0) {
        res.push(
          "调出中数量 " +
            (item.transferOutChangeQuantity > 0 ? "+" : " ") +
            item.transferOutChangeQuantity
        );
      }
      if (item.transferInChangeQuantity && item.transferInChangeQuantity != 0) {
        res.push(
          "调入中数量 " +
            (item.transferInChangeQuantity > 0 ? "+" : " ") +
            item.transferInChangeQuantity
        );
      }
      if (res.length > 0) {
        return res.join(" , ");
      }
      return "—";
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.commoditySpecIdList =
        this.searchData.commoditySpecIdList;
      this.searchParam.changeTypeEnum = this.searchData.changeTypeEnum;
      this.searchParam.minCreateDate = this.searchData.minCreateDate;
      this.searchParam.maxCreateDate = this.searchData.maxCreateDate;
      this.searchParam.frozen = this.searchData.frozen;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      this.searchParam.commodityId = this.commodityId;
      let requestRes =
        await this.$api.commodityQuantityDetail_findPageByCommodity(
          this.searchParam,
          args
        );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CommodityQuantityDetailSearchTable.vue